export const SourceAircraft = "Aircrafts";

export const TitleAircraft = { list: "Aircraft List", edit: "Edit Aircraft", create: "Create Aircraft" };
